module.exports = __webpack_public_path__ + "static/img/shapan3.2305b7a0.png";